import { ref, Ref } from 'vue'

let instance: any = null

export type ImageBoxOptions = {
    onRemove?: any
}

const createInstance = () => {
    const images: Ref<string[]> = ref([])
    const current: Ref<number> = ref(0)
    const visible: Ref<boolean> = ref(false)
    const onRemove: Ref<boolean> = ref(null)

    const show = (imgs: string[], curr = 0, options: ImageBoxOptions = {}) => {
        images.value = imgs
        current.value = curr
        visible.value = true
        onRemove.value = options.onRemove
    }

    const dismiss = () => {
        images.value = []
        visible.value = false
        onRemove.value = null
    }

    return {
        images,
        current,
        visible,
        onRemove,
        show,
        dismiss
    }
}

export const useImageBox = () => {
    if (instance) {
        return {
            imageBox: instance
        }
    }
    instance = createInstance()
    return {
        imageBox: instance
    }
}
